<homey-notification-dialog-content [title]="'Status update'" [closeButton]="closeButton()">
  @let countsValue = counts();
  @if (countsValue.type === 'loading') {
    <div class="flex flex-col gap-3">
      <p-skeleton height="1rem" width="70%"></p-skeleton>
      <div class="flex flex-col gap-2">
        <p-skeleton height="0.9rem" width="90%"></p-skeleton>
        <p-skeleton height="0.9rem" width="85%"></p-skeleton>
        <p-skeleton height="0.9rem" width="80%"></p-skeleton>
      </div>
      <p-skeleton height="1rem" width="60%"></p-skeleton>
    </div>
  } @else {
    @let data = countsValue.data;
    <div class="flex flex-col gap-3">
      <p>Everything looks good, your lotteries are progressing as expected.</p>
      <p>You have <span class="font-bold">{{ data.total }} active applications</span> moving through the selection process:</p>
      <ul class="list-disc pl-4 flex flex-col gap-2">
        @if (data.submittedOpen > 0) {
          <li>{{ data.submittedOpen }} applications submitted, waiting for their lotteries to close.</li>
        }
        @if (data.submittedClosed > 0) {
          <li>{{ data.submittedClosed }} applications for closed lotteries, waiting for lottery nr. drawing.</li>
        }
        @if (data.pendingSelection > 0) {
          <li>{{ data.pendingSelection }} applications have received their lottery nr., waiting to be selected.</li>
        }
      </ul>
    </div>
  }
</homey-notification-dialog-content>
